import React from "react";
import { useTranslation } from "react-i18next";

function AgentACD({ register, errors, setValue }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="margin-top huntgroup">
        <div className="general-settings">{t("Agent")}</div>

        <div className="add-numbermain align-items-start flex-column-sm">
          <div className="tel-numbers">{t("Enagentprecall")}</div>
          <div className="mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="phoneselect width-100">
              <audio src="#" controls className="audio-controls" />
            </div>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span className="routing-edit">{t("edit")}</span>
            </div>
          </div>
        </div>
        <div className="add-numbermain ">
          <div className="tel-numbers">{t("ring_distribution")}</div>
          <div className="phoneselect w-30">
            <select
              className="form-control form-select selectname w-100"
              name="Default"
            >
              <option value="San Jose">{t("Default")}</option>
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
            </select>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("agentringdistribution")}
            <br />
            <span className="phrecording  text-secondary">
              {t("agentringdistributiontxt")}
            </span>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input type="text" value="40" className="selectname w-100" />
              <span className="seconds">{t("seconds")}</span>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("MincallLength")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input type="text" value="0" className="selectname w-100" />
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("AgentUnavacall")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="phrecording  text-secondary me-3">
                {t("CallsallowedtoMiss")}
              </span>
              <input type="text" value="1" className="selectname w-10" />
            </div>
          </div>
        </div>

        <div className="add-numbermain flex-column-sm">
          <div className="tel-numbers">{t("AgentUnavacallDND")}</div>
          <div className="phoneselect mt-5-sm">
            <div className="phoneselect">
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentACD;
